var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEsia(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5505_15570)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.89285 3.00086C9.46272 3.00086 9.13263 3.08089 8.96258 3.15091C8.95258 3.16091 7.75223 3.69106 6.45186 4.45128C5.14148 5.2015 4.08118 5.97172 4.07117 5.98172C3.67106 6.28181 3.20092 7.09204 3.1409 7.59219C3.1409 7.60219 3.00086 8.91257 3.00086 10.413C3.00086 11.9134 3.1409 13.2238 3.1409 13.2438C3.19092 13.744 3.66105 14.5542 4.07117 14.8543C4.08118 14.8643 5.14148 15.6345 6.45186 16.3947C7.76223 17.1449 8.96258 17.6851 8.97258 17.6851C9.14263 17.7551 9.47273 17.8351 9.90285 17.8351C10.333 17.8351 10.6631 17.7551 10.8331 17.6851C10.8431 17.6751 12.0435 17.1449 13.3538 16.3947C14.6542 15.6345 15.7245 14.8643 15.7345 14.8543C16.1346 14.5542 16.6048 13.744 16.6648 13.2438C16.6648 13.2338 16.8048 11.9234 16.8048 10.413C16.8048 8.90256 16.6648 7.59219 16.6648 7.58218C16.6148 7.08204 16.1446 6.27181 15.7345 5.97172C15.7245 5.96172 14.6642 5.1915 13.3538 4.44128C12.0435 3.68106 10.8431 3.15091 10.8331 3.15091C10.6531 3.08089 10.323 3.00086 9.89285 3.00086ZM9.89285 20.836C9.10262 20.836 8.3424 20.696 7.75223 20.4259C7.70222 20.4059 6.40184 19.8257 4.95143 18.9855C3.50101 18.1452 2.35068 17.305 2.30066 17.275C1.22035 16.4847 0.300086 14.8943 0.160046 13.5639C0.150043 13.5039 0 12.0935 0 10.413C0 8.73252 0.150043 7.32211 0.160046 7.26209C0.300086 5.94171 1.22035 4.34125 2.30066 3.56103C2.35068 3.52101 3.50101 2.69078 4.95143 1.85053C6.40184 1.01029 7.70222 0.430124 7.75223 0.410118C8.3524 0.150043 9.11262 0 9.89285 0C10.453 0 11.2732 0.0700202 12.0335 0.410118C12.0835 0.430124 13.3839 1.01029 14.8343 1.85053C16.2847 2.69078 17.435 3.52101 17.485 3.56103C18.5653 4.35125 19.4856 5.94171 19.6257 7.27209C19.6357 7.33211 19.7857 8.74252 19.7857 10.423C19.7857 12.1035 19.6357 13.5139 19.6257 13.5739C19.4856 14.9043 18.5653 16.4948 17.485 17.285C17.435 17.325 16.2847 18.1552 14.8343 18.9955C13.3839 19.8357 12.0835 20.4059 12.0335 20.4359C11.2732 20.766 10.453 20.836 9.89285 20.836Z",
    fill: "url(#paint0_linear_5505_15570)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5505_15570",
    x1: 9.89285,
    y1: 0,
    x2: 9.89285,
    y2: 20.836,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#175FA9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9324E"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5505_15570"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.7857,
    height: 20.836,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEsia);
export default __webpack_public_path__ + "static/media/esia.6439d131.svg";
export { ForwardRef as ReactComponent };